import { motion } from "framer-motion";
import { WHATSAPP_URL } from "../../lib/site";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const FloatingWhatsApp = () => (
  <motion.a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="floating-whatsapp-button"
    aria-label="Chat on WhatsApp"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.6, type: "spring", stiffness: 200, damping: 16 }}
    whileHover={{ scale: 1.08 }}
    className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#1f9d55] text-white shadow-[0_10px_40px_rgba(31,157,85,0.45)] ring-1 ring-[#D4AF37]/40 sm:bottom-7 sm:right-7"
  >
    <span className="absolute inset-0 animate-ping rounded-full bg-[#1f9d55]/30" style={{ animationDuration: "2.8s" }} />
    <WhatsAppIcon className="relative h-6 w-6" />
  </motion.a>
);
